<template>
  <div>
    <b-card header-tag="header" class="header m-0 h-100">
      <!-- Header -->
      <template #header>
        <i class="mdi mdi-lock-clock mr-1" style="font-size: 1.3rem"></i>
        <strong class="mb-0 p-0">{{ $t('login_history') }}</strong>
      </template>
      <!-- Content -->
      <b-card-text class="text-left content">
        <b-spinner v-if="isLoading" label="Cargando..." variant="secondary" small class="mb-2" ></b-spinner>
        <div v-if="!isLoading">
          <a-timeline
          class="p-4"
          v-if="movements.items.length"
          >
            <a-timeline-item
            v-for="(m, index) of movements.items"
            :key="index"
            >
              <div class="datos d-flex flex-column mx-2">
                <span>
                  <b-avatar
                    class="my-1"
                    size="2.2em"
                    variant="primary"
                    :src="m.avatar"
                    ></b-avatar>
                  <span class="mx-2"><strong>{{`${userFullName(m)}`}}</strong>{{` ${m.activity}`}}</span>
                </span>
                <span
                  v-if="m.createdAt"
                  class="font-weight-light my-1"
                >
                  {{ m.createdAt }}
                </span>
                <a @click="showDetails(index)" class="link-primary">{{ m.show ? 'Ocultar detalle' : 'Ver detalle' }}</a>
                <div v-if="m.show" class="mt-2">
                  <div v-if="m.createdBy.userAgent" class="mt-0"><strong>Agente:</strong> {{m.createdBy.userAgent}}</div>
                  <div v-if="m.createdBy.userIp"><strong>IP:</strong> {{m.createdBy.userIp}}</div>
                </div>
              </div>
            </a-timeline-item>
          </a-timeline>
          <LmError v-else/>
        </div>
      </b-card-text>
    </b-card>
  </div>
</template>

<script>
import commonsApi from '@/api/commons'
import LmError from '@/components/LmError.vue'

export default {
  data () {
    return {
      toggleLoginHistory: null,
      isLoading: false,
      movements: {
        items: []
      }
    }
  },
  components: {
    LmError
  },
  computed: {
  },
  props: {
    value: {
      type: Object,
      required: true
    }
  },
  methods: {
    async getResponse () {
      try {
        this.isLoading = true

        const historyResponse = await commonsApi.axiosGetWrapper(`/users/loghistory/${this.value.id}`)

        this.movements.items = historyResponse.data || []
        this.movements.items = this.movements.items.map(item => {
          item.show = false
          return item
        })
        this.toggleLoginHistory = !this.toggleLoginHistory
      } catch (error) {
        console.log(error)
      } finally {
        this.isLoading = false
      }
    },
    userFullName (m) {
      return `${m.createdBy?.user.firstname} ${m.createdBy?.user.lastname}`
    },
    showDetails (index) {
      if (!this.movements.items[index].show) {
        this.movements.items[index].show = true
      } else {
        this.movements.items[index].show = false
      }
      this.$forceUpdate()
    }
  },
  created () {
    this.getResponse()
  }
}
</script>

<style scoped>
.content {
  max-height: 300px;
  margin-bottom: 23px;
  overflow: scroll;
}
</style>
